import { render, staticRenderFns } from "./RemittancePdfInvoice.vue?vue&type=template&id=66888fe9&"
import script from "./RemittancePdfInvoice.vue?vue&type=script&lang=ts&"
export * from "./RemittancePdfInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports